var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { PeekIconButton, PeekTooltip, PeekTypography, PeekBox, } from "@piiqtechnologies/ui-components";
const ActionButton = (_a) => {
    var { Icon, height, width } = _a, props = __rest(_a, ["Icon", "height", "width"]);
    return (React.createElement(PeekIconButton, Object.assign({ sx: { height: 25, width: 25, border: 0, bgcolor: "transparent" } }, props),
        React.createElement(PeekTypography, { color: (!props.disabled && "primary") || "grey.200", lineHeight: 0 },
            React.createElement(Icon, { height: height, width: width }))));
};
export const TableActionButton = (_a) => {
    var { tooltip, height = 16, width = 16 } = _a, props = __rest(_a, ["tooltip", "height", "width"]);
    if (tooltip) {
        return (React.createElement(PeekTooltip, { placement: "bottom", title: React.createElement(React.Fragment, null, tooltip) },
            React.createElement(PeekBox, null,
                React.createElement(ActionButton, Object.assign({ height: height, width: width }, props)))));
    }
    return React.createElement(ActionButton, Object.assign({}, props));
};
export default TableActionButton;
